export const HexColorRE = /^#([\da-fA-F]{6})$/;

export const isHexColor = value => value && value.match(HexColorRE);

export const isDark = hex => {
  // Early return if proper hex color code is not passed
  if (!isHexColor(hex)) return false;

  const hexToChannelValue = (hex, idx) => parseInt(hex.substr(idx, 2), 16);
  const channelValue = hexToChannelValue.bind(undefined, hex);
  const r = channelValue(1);
  const g = channelValue(3);
  const b = channelValue(5);
  let l = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
  return (l + 0.05) / 0.05 <= 14;
};
